<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <i class="fa-regular fa-lightbulb-on icon"></i>
        <span>Sugestões</span>
      </h1>
      <router-link :to="{ name: 'suggestionCreate' }">
        <PrimaryButton class="px-5" icon="fa-solid fa-solid fa-plus">Nova sugestão</PrimaryButton>
      </router-link>
    </div>
  </div>


  <div class="align p-4 space_title">
    <div v-if="!loading || suggestions.data">
          <div class="card p-4 mb-3" v-for="(suggestion, key) in suggestions.data" :key="key">
            <h5>{{ suggestion.title }}</h5>
            <p>
              {{ $dateFormat(suggestion.created_at) }}
            </p>
            <p class="mb-0">
              {{ suggestion.content }}
            </p>
          </div>
          <div class="no_result" v-if="suggestions.data && !suggestions.data.length">
              Nenhum resultado encontrado
          </div>
    </div>

    <ListPagination class="mt-4" :links="suggestions.meta.links" />
  </div>

  <ModalDialog v-model="showDestroyPageModal">
    <h6>Deseja realmente remover este registro?</h6>

    <div class="modal_actions">
      <WhiteButton>Cancelar</WhiteButton>
      <PrimaryButton class="red" @click="deletePage()">Remover</PrimaryButton>
    </div>
  </ModalDialog>
</template>
  
<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import WhiteButton from '@/components/WhiteButton.vue'
import { onBeforeMount, ref, watch } from 'vue';
import { useSuggestionStore } from '@/stores/SuggestionStore'
import { storeToRefs } from 'pinia';
import ListPagination from '@/components/ListPagination.vue'
import { inject } from 'vue';
import { useRoute } from 'vue-router';
import ModalDialog from '@/components/ModalDialog.vue';

const loader = inject('$loader');
const loading = ref(false);

const route = useRoute();
const suggestionStore = useSuggestionStore();
const { suggestions, filter } = storeToRefs(suggestionStore);


onBeforeMount(() => {
  loadSuggestions();
});

watch(() => route.query.page, () => {
  window.scrollTo(0, 0);
  loadSuggestions();
});

watch(() => route.query.suggestion, (newPage, oldPage) => {
  if (newPage !== oldPage) {
    window.scrollTo(0, 0);
    loadSuggestions();
  }
});

async function loadSuggestions() {
  loader.show();
  loading.value = true;

  filter.value.suggestion = parseInt(route.query.suggestion);
  filter.value.page = parseInt(route.query.page);
  filter.value.limit = 10;

  await suggestionStore.getSuggestions();
  loader.hide();
  loading.value = false;
}
</script>